<template>
  <div class="bg-[#16131B] h-[72px] flex justify-center" ref="navbarContainer">
    <div class="xxl:max-w-[1312px] w-full flex justify-between items-center px-6 py-3">
      <div class="flex gap-[24px]">
        <!-- Logo -->
        <div>
          <a :href="goToWebsite('/')">
            <img :src="ohbbLogo" class="w-[36px]" alt="Oh Baby Games logo" loading="eager" />
          </a>
        </div>
        <!-- Navigation -->
        <div class="flex-row items-center gap-8 text-[#9C93B3] font-['Rubik'] text-sm font-[400] navlg:flex hidden">
          <div class="dropdown" ref="dropdown">
            <div
              class="flex flex-row items-center cursor-pointer text-[#9C93B3] hover:text-[#EFEDF2]"
              @click="clickOBK">
              Games
              <img
                :src="arrowDownSvg"
                alt="chevron"
                class="w-3 h-3 ml-1"
                loading="eager"
                :class="
                  OBKVisibility === 'flex'
                    ? 'rotate-180 transform transition-transform'
                    : 'transform transition-transform'
                " />
            </div>
            <transition name="dropdown-fade">
              <div v-if="OBKVisibility === 'flex'" class="w-full absolute z-[100] bg-[#221E2A] mt-[26px] left-0">
                <GamesSectionNavbar />
              </div>
            </transition>
          </div>

          <div class="dropdown" ref="dropdown">
            <div class="flex flex-row items-center cursor-pointer text-[#9C93B3] hover:text-[#EFEDF2]" @click="clickLB">
              Leaderboards
              <img
                :src="arrowDownSvg"
                alt="chevron"
                class="w-3 h-3 ml-1"
                loading="eager"
                :class="
                  LBVisibility === 'flex'
                    ? 'rotate-180 transform transition-transform'
                    : 'transform transition-transform'
                " />
            </div>
            <transition name="dropdown-fade">
              <div v-if="LBVisibility === 'flex'" class="w-[149px] absolute z-[100] bg-[#322C3F] rounded-lg mt-[26px]">
                <div class="text-[#EFEDF2] font-['Rubik'] text-sm font-[400] flex flex-col py-2">
                  <a
                    :href="goToWebsite('/leaderboard/oh-baby-kart')"
                    class="mx-[16px] my-[10px] flex flex-row items-center gap-2">
                    <img
                      :src="obkIcon"
                      alt="Oh Baby Kart icon"
                      class="w-[24px] h-[24px] rounded-[4px] cursor-pointer"
                      loading="eager" />
                    Oh Baby Kart
                  </a>
                  <a
                    :href="goToWebsite('/leaderboard/pawker')"
                    class="mx-[16px] my-[10px] flex flex-row items-center gap-2">
                    <img
                      :src="pawkerIcon"
                      alt="Pawker icon"
                      class="w-[24px] h-[24px] rounded-[4px] cursor-pointer"
                      loading="eager" />
                    Pawker
                  </a>
                </div>
              </div>
            </transition>
          </div>

          <a :onclick="goToSite" class="hover:text-[#EFEDF2] cursor-pointer">Website</a>
          <a :onclick="goToMarketplace" class="hover:text-[#EFEDF2] cursor-pointer">Marketplace</a>
          <a :href="goToWebsite('/news')" class="hover:text-[#EFEDF2]">News</a>
          <a :href="goToWebsite('/support')" class="hover:text-[#EFEDF2]">Support</a>

          <div class="dropdown" ref="dropdown">
            <div class="flex flex-row items-center cursor-pointer text-[#9C93B3] hover:text-[#EFEDF2]" @click="clickLM">
              Learn More
              <img
                :src="arrowDownSvg"
                alt="chevron"
                class="w-3 h-3 ml-1"
                loading="eager"
                :class="
                  LMVisibility === 'flex'
                    ? 'rotate-180 transform transition-transform'
                    : 'transform transition-transform'
                " />
            </div>
            <transition name="dropdown-fade">
              <div v-if="LMVisibility === 'flex'" class="w-[129px] absolute z-[100] bg-[#322C3F] rounded-lg mt-[26px]">
                <div class="text-[#EFEDF2] font-['Rubik'] text-sm font-[400] flex flex-col py-2">
                  <a :href="goToWebsite('/about-us')" class="mx-[16px] my-[10px]">Company</a>
                  <a :href="goToWebsite('/careers')" class="mx-[16px] my-[10px]">Work With Us</a>
                  <a :href="goToWebsite('/developers')" class="ml-[16px] my-[10px]">Partner With Us</a>
                </div>
              </div>
            </transition>
          </div>

          <div class="dropdown" ref="dropdown" v-if="userToken">
            <div
              class="flex flex-row items-center cursor-pointer text-[#9C93B3] hover:text-[#EFEDF2]"
              @click="clickPass">
              OBB Pass
              <img
                :src="arrowDownSvg"
                alt="chevron"
                class="w-3 h-3 ml-1"
                loading="eager"
                :class="
                  PassVisibility === 'flex'
                    ? 'rotate-180 transform transition-transform'
                    : 'transform transition-transform'
                " />
              <div class="text-primaryRed text-xs font-medium leading-3 p-2 bg-[#28010A] rounded-3xl ml-[8px]">New</div>
            </div>
            <transition name="dropdown-fade">
              <div
                v-if="PassVisibility === 'flex'"
                class="w-[129px] absolute z-[100] bg-[#322C3F] rounded-lg mt-[22px]">
                <div class="text-[#EFEDF2] font-['Rubik'] text-sm font-[400] flex flex-col py-2">
                  <a :href="goToWebsite('/pass')" class="mx-[16px] my-[10px]">My NFTs</a>
                  <a :href="goToWebsite('/pass/leaderboard/1')" class="mx-[16px] my-[10px]">OBB Passes</a>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
      <!-- Account/Play/Hamburger -->
      <div class="flex flex-row items-center gap-6 relative">
        <div class="dropdown" ref="dropdown">
          <div class="flex flex-row items-center gap-[24px] cursor-pointer">
            <button
              @click="goToLearnMore"
              class="navlg:flex hidden secondary-large w-[101px] h-[32px] font-Rubik text-mainText font-medium whitespace-nowrap sm:flex items-center justify-center">
              <img :src="arrowDownIcon" class="w-[12px] h-[12px] download-btn" alt="Download icon" loading="eager" />
              <span class="button-small ml-[4px]">Install app</span>
            </button>
            <div class="flex items-center gap-[8px]" @click="clickAccount">
              <div class="bg-[#483F5A] w-8 h-8 flex items-center justify-center rounded-[100px]">
                <img :src="userData ? userData.image : pfpSvg" class="rounded-full" alt="User avatar" />
              </div>
              <img
                :src="arrowDownSvg"
                alt="chevron"
                class="w-3 h-3"
                loading="eager"
                :class="
                  LoginVisibility === 'flex'
                    ? 'rotate-180 transform transition-transform'
                    : 'transform transition-transform'
                " />
            </div>
          </div>

          <transition name="dropdown-fade">
            <div
              v-if="!userToken && LoginVisibility === 'flex'"
              class="w-[129px] absolute z-[100] bg-[#322C3F] rounded-lg mt-[20px] navlg:right-[1%] xl:right-[1%] right-[5%] xxxl:right-[1%]">
              <div class="text-[#EFEDF2] font-['Rubik'] text-sm font-[400] flex flex-col py-2">
                <a @click.prevent="login" class="mx-[16px] my-[10px] cursor-pointer">Login</a>
                <a @click.prevent="signup" class="mx-[16px] my-[10px] cursor-pointer">Sign Up</a>
              </div>
            </div>
          </transition>

          <transition name="dropdown-fade">
            <div
              v-if="userToken && LoginVisibility === 'flex'"
              class="w-[250px] absolute z-[100] bg-[#322C3F] rounded-lg mt-[15px] navlg:right-[1%] xl:right-[1%] right-[5%] sm:right-[7%] xxxl:right-[1%]">
              <div class="text-[#EFEDF2] font-['Rubik'] text-sm font-[400] flex flex-col w-full py-2">
                <div class="flex flex-row items-center gap-2 border-b-[1px] border-[#483f5a] pt-2 px-4 pb-[20px]">
                  <div
                    class="bg-[#483F5A] w-8 h-8 flex items-center justify-center rounded-[100px] cursor-pointer"
                    @click="clickAccount">
                    <img
                      :src="userData ? userData.image : pfpSvg"
                      class="rounded-full cursor-default"
                      alt="User avatar" />
                  </div>
                  <div class="max-w-[170px] overflow-hidden">
                    <h1 class="text-base font-medium text-left truncate text-mainText font-Rubik">
                      {{ userData ? userData.displayName : '' }}
                    </h1>
                    <p class="text-xs font-normal text-left truncate text-secText font-Rubik">
                      {{ userData ? userData.email : '' }}
                    </p>
                  </div>
                </div>

                <div class="px-4 py-1 border-b-[1px] border-[#483f5a] flex flex-row items-center">
                  <div class="flex flex-row items-center gap-2 cursor-pointer" @click="goToSettings">
                    <img :src="settingsIcon" class="w-[20px] h-[20px]" alt="Settings icon" loading="eager" />
                    <h1 class="font-Rubik py-[10px] text-sm font-normal">Account Settings</h1>
                  </div>
                </div>

                <div class="flex flex-row items-center px-4 py-1">
                  <div class="flex flex-row items-center gap-2 cursor-pointer" @click="logout">
                    <img :src="logoutIcon" class="w-[20px] h-[20px]" alt="Logout icon" loading="eager" />
                    <h1 class="font-Rubik py-[10px] text-sm font-normal">Log out</h1>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>

        <!-- Hamburger Menu -->
        <div
          class="hamburger hamburger--vortex navlg:hidden"
          :class="showMenu ? 'is-active' : ''"
          @click="toggleHamburgerMenu">
          <div class="hamburger-box">
            <div class="hamburger-inner"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Backdrop overlay -->
    <transition name="backdrop-fade" @before-enter="onMenuTransitionStart" @after-leave="onMenuTransitionEnd">
      <div
        v-if="showMenu"
        class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-[99] navlg:hidden top-[72px]"
        @click="toggleHamburgerMenu" />
    </transition>

    <!-- Hamburger menu content -->
    <transition
      name="menu-slide"
      @before-enter="onMenuTransitionStart"
      @after-enter="onMenuTransitionEnd"
      @before-leave="onMenuTransitionStart"
      @after-leave="onMenuTransitionEnd">
      <div
        v-show="showMenu"
        class="w-full bg-[#16131B] absolute navlg:hidden z-[100] mt-[72px] max-h-[calc(100vh-72px)] overflow-y-auto overscroll-contain mobile-menu-container">
        <div class="text-[#9C93B3] font-['Rubik'] text-base font-[600] flex flex-col">
          <a
            :href="goToWebsite('/overview')"
            class="py-[14px] px-[32px] flex flex-row items-center justify-between cursor-pointer bg-[#16131B] active:bg-[#322C3F] transition-colors duration-150 touch-manipulation">
            Oh Baby! Kart
          </a>
          <a
            :href="goToWebsite('/shogun-curse')"
            class="py-[14px] px-[32px] cursor-pointer active:bg-[#322C3F] transition-colors duration-150 touch-manipulation"
            >Shogun Curse</a
          >
          <a
            :href="goToWebsite('/bam-bam-boom')"
            class="py-[14px] px-[32px] cursor-pointer active:bg-[#322C3F] transition-colors duration-150 touch-manipulation"
            >Bam Bam Boom</a
          >
          <a
            :href="goToWebsite('/pawker')"
            class="py-[14px] px-[32px] cursor-pointer active:bg-[#322C3F] transition-colors duration-150 touch-manipulation"
            >Pawker</a
          >
          <div
            class="py-[14px] px-[32px] flex flex-row items-center justify-between cursor-pointer text-[#9C93B3] touch-manipulation transition-colors duration-150"
            @click="clickOBK"
            :class="
              OBKVisibility === 'flex'
                ? 'bg-[#322C3F] border-l-[#ED063D] border-l-[2px]'
                : 'bg-[#16131B] active:bg-[#322C3F]'
            ">
            Inside OBK
            <img
              :src="arrowDownSvg"
              alt="chevron"
              class="w-4 h-4 ml-1 transition-transform duration-300 ease-in-out"
              loading="eager"
              :class="OBKVisibility === 'flex' ? 'rotate-180' : ''" />
          </div>
          <transition
            name="dropdown-fade"
            @before-enter="onDropdownTransitionStart"
            @after-enter="onDropdownTransitionEnd"
            @before-leave="onDropdownTransitionStart"
            @after-leave="onDropdownTransitionEnd">
            <div v-if="OBKVisibility === 'flex'" class="flex flex-col bg-[#0E0D12] px-[32px]">
              <a
                :href="goToWebsite('/overview')"
                class="py-[12px] text-[#9C93B3] transition-colors duration-150 touch-manipulation"
                >How to play</a
              >
              <a
                :href="goToWebsite('/twitch-drops')"
                class="py-[12px] text-[#9C93B3] transition-colors duration-150 touch-manipulation"
                >Twitch Drops</a
              >
              <a
                target="_blank"
                href="https://ohbabykart.wiki.gg/wiki/Characters"
                class="py-[12px] text-[#9C93B3] transition-colors duration-150 touch-manipulation"
                >Heroes</a
              >
              <a
                :href="goToWebsite('/stages')"
                class="py-[12px] text-[#9C93B3] transition-colors duration-150 touch-manipulation"
                >Stages</a
              >
            </div>
          </transition>

          <div
            class="py-[14px] px-[32px] flex flex-row items-center justify-between cursor-pointer text-[#9C93B3] touch-manipulation transition-colors duration-150"
            @click="clickLB"
            :class="
              LBVisibility === 'flex'
                ? 'bg-[#322C3F] shadow-[inset_#ED063D_2px_0px_0px_0px]'
                : 'bg-[#16131B] active:bg-[#322C3F]'
            ">
            Leaderboards
            <img
              :src="arrowDownSvg"
              alt="chevron"
              class="w-4 h-4 ml-1 transition-transform duration-300 ease-in-out"
              loading="eager"
              :class="LBVisibility === 'flex' ? 'rotate-180' : ''" />
          </div>
          <transition
            name="dropdown-fade"
            @before-enter="onDropdownTransitionStart"
            @after-enter="onDropdownTransitionEnd"
            @before-leave="onDropdownTransitionStart"
            @after-leave="onDropdownTransitionEnd">
            <div v-if="LBVisibility === 'flex'" class="flex flex-col bg-[#0E0D12] px-[32px]">
              <a
                :href="goToWebsite('/leaderboard/oh-baby-kart')"
                class="py-[12px] text-[#9C93B3] transition-colors duration-150 touch-manipulation"
                >Oh Baby Kart</a
              >
              <a
                :href="goToWebsite('/leaderboard/pawker')"
                class="py-[12px] text-[#9C93B3] transition-colors duration-150 touch-manipulation"
                >Pawker</a
              >
            </div>
          </transition>
          <a
            :onclick="goToSite"
            class="py-[14px] px-[32px] cursor-pointer active:bg-[#322C3F] transition-colors duration-150 touch-manipulation"
            >Website</a
          >
          <a
            :onclick="goToMarketplace"
            class="py-[14px] px-[32px] cursor-pointer active:bg-[#322C3F] transition-colors duration-150 touch-manipulation"
            >Marketplace</a
          >
          <a
            :href="goToWebsite('/news')"
            class="py-[14px] px-[32px] active:bg-[#322C3F] transition-colors duration-150 touch-manipulation"
            >News</a
          >
          <a
            :href="goToWebsite('/support')"
            class="py-[14px] px-[32px] active:bg-[#322C3F] transition-colors duration-150 touch-manipulation"
            >Support</a
          >

          <div
            class="py-[14px] px-[32px] flex flex-row items-center justify-between cursor-pointer text-[#9C93B3] touch-manipulation transition-colors duration-150"
            @click="clickLM"
            :class="
              LMVisibility === 'flex'
                ? 'bg-[#322C3F] shadow-[inset_#ED063D_2px_0px_0px_0px]'
                : 'bg-[#16131B] active:bg-[#322C3F]'
            ">
            Learn More
            <img
              :src="arrowDownSvg"
              alt="chevron"
              class="w-4 h-4 ml-1 transition-transform duration-300 ease-in-out"
              loading="eager"
              :class="LMVisibility === 'flex' ? 'rotate-180' : ''" />
          </div>
          <transition
            name="dropdown-fade"
            @before-enter="onDropdownTransitionStart"
            @after-enter="onDropdownTransitionEnd"
            @before-leave="onDropdownTransitionStart"
            @after-leave="onDropdownTransitionEnd">
            <div v-if="LMVisibility === 'flex'" class="flex flex-col bg-[#0E0D12] px-[32px]">
              <a
                :href="goToWebsite('/about-us')"
                class="py-[12px] text-[#9C93B3] transition-colors duration-150 touch-manipulation"
                >Company</a
              >
              <a
                :href="goToWebsite('/careers')"
                class="py-[12px] text-[#9C93B3] transition-colors duration-150 touch-manipulation"
                >Work With Us</a
              >
              <a
                :href="goToWebsite('/developers')"
                class="py-[12px] text-[#9C93B3] transition-colors duration-150 touch-manipulation"
                >Partner With Us</a
              >
            </div>
          </transition>

          <div
            v-if="userToken"
            class="py-[14px] px-[32px] flex flex-row items-center justify-between cursor-pointer touch-manipulation transition-colors duration-150"
            @click="clickPass"
            :class="
              PassVisibility === 'flex'
                ? 'bg-[#322C3F] shadow-[inset_#ED063D_2px_0px_0px_0px]'
                : 'bg-[#16131B] active:bg-[#322C3F]'
            ">
            <div class="flex flex-row items-center justify-center text-[#9C93B3]">
              OBB Pass
              <div class="text-primaryRed text-xs font-medium leading-3 p-2 bg-[#28010A] rounded-3xl ml-[8px]">New</div>
            </div>
            <img
              :src="arrowDownSvg"
              alt="chevron"
              class="w-4 h-4 ml-1 transition-transform duration-300 ease-in-out"
              loading="eager"
              :class="PassVisibility === 'flex' ? 'rotate-180' : ''" />
          </div>
          <transition
            name="dropdown-fade"
            @before-enter="onDropdownTransitionStart"
            @after-enter="onDropdownTransitionEnd"
            @before-leave="onDropdownTransitionStart"
            @after-leave="onDropdownTransitionEnd">
            <div v-if="PassVisibility === 'flex'" class="flex flex-col bg-[#0E0D12] px-[32px]">
              <a
                :href="goToWebsite('/pass')"
                class="py-[12px] text-[#9C93B3] transition-colors duration-150 touch-manipulation"
                >My NFTs</a
              >
              <a
                :href="goToWebsite('/pass/leaderboard/1')"
                class="py-[12px] text-[#9C93B3] transition-colors duration-150 touch-manipulation"
                >OBB Passes</a
              >
            </div>
          </transition>
        </div>

        <div class="flex flex-row items-center px-4 py-[10px] cursor-pointer">
          <button
            @click="goToLearnMore"
            class="flex secondary-large w-full sm:hidden h-[48px] font-Rubik text-mainText font-medium whitespace-nowrap items-center justify-center">
            <img :src="arrowDownIcon" class="size-[24px]" alt="Download icon" loading="eager" />
            <span class="button-large ml-[4px]">Install app</span>
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import personSvg from '@/assets/icons/person.svg';
import ohbbLogo from '@/assets/svgs/ohbb_logo.svg';
import arrowDownSvg from '@/assets/images/homepage/arrow-filled-down.svg';
import arrowDownIcon from '@/assets/icons/download.svg';
import settingsIcon from '@/assets/icons/settings.svg';
import logoutIcon from '@/assets/icons/logout.svg';
import obkIcon from '@/assets/images/gamesnavbar/obk-icon-with-black.jpg';
import pawkerIcon from '@/assets/images/gamesnavbar/pawker-icon.png';

import envConfig from '../config';
import axios from 'axios';

import './hamburger.css';

import GamesSectionNavbar from './GamesSectionNavbar.vue';

export default {
  components: { GamesSectionNavbar },

  data() {
    return {
      OBKVisibility: 'hidden',
      LMVisibility: 'hidden',
      LBVisibility: 'hidden',
      PassVisibility: 'hidden',
      LoginVisibility: 'hidden',
      showMenu: false,
      isMenuTransitioning: false,
      menuToggleTimeout: null,
      isDropdownTransitioning: false,
      dropdownToggleTimeout: null,
      userToken: null,
      userData: null,
      allow_store: false,

      ohbbLogo,
      arrowDownSvg,
      arrowDownIcon,
      settingsIcon,
      logoutIcon,
      obkIcon,
      pawkerIcon,
    };
  },

  mounted() {
    this.userToken = window.getCookie('obb_ck');
    this.fetchUser();
    this.setupClickOutsideHandler();
    this.preloadImages();
    this.setupResizeHandler();
  },

  watch: {
    showMenu(newVal) {
      this.toggleBodyOverflow(newVal);
    },
  },

  beforeUnmount() {
    document.body.style.overflow = '';
    this.removeClickOutsideHandler();
    this.removeResizeHandler();
    if (this.menuToggleTimeout) {
      clearTimeout(this.menuToggleTimeout);
    }
    if (this.dropdownToggleTimeout) {
      clearTimeout(this.dropdownToggleTimeout);
    }
  },

  methods: {
    closeAllDropdowns() {
      this.OBKVisibility = 'hidden';
      this.LMVisibility = 'hidden';
      this.LBVisibility = 'hidden';
      this.LoginVisibility = 'hidden';
      this.PassVisibility = 'hidden';
    },

    toggleDropdown(dropdownName) {
      if (this.isDropdownTransitioning) {
        return;
      }

      const visibilityKey = `${dropdownName}Visibility`;
      const isHidden = this[visibilityKey] === 'hidden';

      this.isDropdownTransitioning = true;

      if (isHidden) {
        this.closeAllDropdowns();
        this[visibilityKey] = 'flex';
      } else {
        this[visibilityKey] = 'hidden';
      }

      if (this.dropdownToggleTimeout) {
        clearTimeout(this.dropdownToggleTimeout);
      }

      this.dropdownToggleTimeout = setTimeout(() => {
        this.isDropdownTransitioning = false;
        this.dropdownToggleTimeout = null;
      }, 300);
    },

    onDropdownTransitionStart() {
      if (!this.isDropdownTransitioning) {
        this.isDropdownTransitioning = true;
      }
    },

    onDropdownTransitionEnd() {
      if (this.dropdownToggleTimeout) {
        clearTimeout(this.dropdownToggleTimeout);
      }
      this.dropdownToggleTimeout = setTimeout(() => {
        this.isDropdownTransitioning = false;
        this.dropdownToggleTimeout = null;
      }, 50);
    },

    clickOBK() {
      this.toggleDropdown('OBK');
    },

    clickLB() {
      this.toggleDropdown('LB');
    },

    clickLM() {
      this.toggleDropdown('LM');
    },

    clickPass() {
      this.toggleDropdown('Pass');
    },

    clickAccount() {
      this.toggleDropdown('Login');
    },

    toggleHamburgerMenu() {
      if (this.isMenuTransitioning) {
        return;
      }

      this.isMenuTransitioning = true;

      this.showMenu = !this.showMenu;
      this.closeAllDropdowns();

      if (this.menuToggleTimeout) {
        clearTimeout(this.menuToggleTimeout);
      }

      this.menuToggleTimeout = setTimeout(() => {
        this.isMenuTransitioning = false;
        this.menuToggleTimeout = null;
      }, 350);
    },

    onMenuTransitionStart() {
      if (!this.isMenuTransitioning) {
        this.isMenuTransitioning = true;
      }
    },

    onMenuTransitionEnd() {
      if (this.menuToggleTimeout) {
        clearTimeout(this.menuToggleTimeout);
      }
      this.menuToggleTimeout = setTimeout(() => {
        this.isMenuTransitioning = false;
        this.menuToggleTimeout = null;
      }, 50);
    },

    closeMobileMenu() {
      if (this.showMenu) {
        this.showMenu = false;
        this.closeAllDropdowns();
      }
    },

    joinWaitlist() {
      if (!this.userToken) {
        window.location.href = envConfig.websiteUrl + `/login?signup`;
      } else if (this.userToken) {
        window.location.href = envConfig.websiteUrl + `/profile`;
      }
    },

    login() {
      window.location.href = `${envConfig.websiteUrl}/login?from=store`;
    },

    logout() {
      let cookieValue = this.userToken;
      let expDate = new Date();
      expDate.setFullYear(expDate.getFullYear() - 1);
      document.cookie =
        'obb_ck=' +
        cookieValue +
        ';expires=' +
        expDate +
        (window.location.hostname !== 'localhost' ? ';domain=.ohbabygames.com' : '') +
        ';path=/';

      window.location.href = '/';
    },

    signup() {
      window.location.href = envConfig.websiteUrl + `/login?signup`;
    },

    goToSite() {
      window.location.href = envConfig.websiteUrl;
    },

    goToMarketplace() {
      window.location.href = envConfig.websiteUrl + '/marketplace';
    },

    fetchUser() {
      const url = envConfig.baseUrl + '/api/user';

      if (this.userToken) {
        axios
          .get(url, {
            headers: {
              Authorization: `Bearer ${this.userToken}`,
              'Content-Type': 'application/json',
            },
          })
          .then((response) => {
            const data = response.data;
            this.userData = data.data;
            if (this.userData.allow_store) {
              this.allow_store = true;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    goToLearnMore() {
      window.location.href = envConfig.websiteUrl + '/download-platform';
    },

    goToSettings() {
      window.location.href = envConfig.websiteUrl + '/account-settings';
    },

    claimSteamKey() {
      window.location.href = envConfig.websiteUrl + '/profile';
    },

    goToWebsite(relPath) {
      if (relPath) {
        return envConfig.websiteUrl + relPath;
      } else {
        return envConfig.websiteUrl;
      }
    },

    toggleBodyOverflow(isHidden) {
      document.body.style.overflow = isHidden ? 'hidden' : '';
    },

    handleClickOutside(event) {
      const navbar = this.$refs.navbarContainer;
      const isClickInsideNavbar = navbar && navbar.contains(event.target);
      const isClickOnDropdown = event.target.closest('[class*="absolute"]');

      if (!isClickInsideNavbar && !isClickOnDropdown) {
        this.closeAllDropdowns();
      }
    },

    setupClickOutsideHandler() {
      this.clickOutsideHandler = this.handleClickOutside.bind(this);
      document.addEventListener('click', this.clickOutsideHandler);
    },

    removeClickOutsideHandler() {
      if (this.clickOutsideHandler) {
        document.removeEventListener('click', this.clickOutsideHandler);
      }
    },

    handleResize() {
      if (window.innerWidth >= 1130 && this.showMenu) {
        this.closeMobileMenu();
      }
    },

    setupResizeHandler() {
      this.resizeHandler = this.handleResize.bind(this);
      window.addEventListener('resize', this.resizeHandler);
    },

    removeResizeHandler() {
      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler);
      }
    },

    preloadImages() {
      const imagesToPreload = [ohbbLogo, arrowDownSvg, arrowDownIcon, settingsIcon, logoutIcon, obkIcon, pawkerIcon];

      imagesToPreload.forEach((src) => {
        const img = new Image();
        img.src = src;
      });
    },
  },

  computed: {
    pfpSvg() {
      return personSvg;
    },
  },
};
</script>

<style scoped>
.profile-name {
  max-width: 190px;
}

@media all and (max-width: 320px) {
  .profile-name {
    max-width: 120px;
  }
}

.download-btn {
  filter: brightness(0) invert(1);
}

.dropdown-fade-enter-active {
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.dropdown-fade-leave-active {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.dropdown-fade-enter-from {
  opacity: 0;
  transform: translateY(-8px);
}

.dropdown-fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

.dropdown-fade-enter-to,
.dropdown-fade-leave-from {
  opacity: 1;
  transform: translateY(0);
}

/* Mobile menu slide animation */
.menu-slide-enter-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.menu-slide-leave-active {
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.menu-slide-enter-from {
  opacity: 0;
  transform: translateY(-20px);
}

.menu-slide-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

.menu-slide-enter-to,
.menu-slide-leave-from {
  opacity: 1;
  transform: translateY(0);
}

/* Backdrop fade animation */
.backdrop-fade-enter-active {
  transition: opacity 0.3s ease;
}

.backdrop-fade-leave-active {
  transition: opacity 0.25s ease;
}

.backdrop-fade-enter-from,
.backdrop-fade-leave-to {
  opacity: 0;
}

.backdrop-fade-enter-to,
.backdrop-fade-leave-from {
  opacity: 1;
}

@media (hover: none) and (pointer: coarse) {
  .touch-manipulation {
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;
  }
}

.mobile-menu-container {
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  will-change: transform, opacity;
}

.mobile-menu-container::-webkit-scrollbar {
  width: 6px;
}

.mobile-menu-container::-webkit-scrollbar-track {
  background: #16131b;
}

.mobile-menu-container::-webkit-scrollbar-thumb {
  background: #322c3f;
  border-radius: 3px;
}

.mobile-menu-container::-webkit-scrollbar-thumb:hover {
  background: #483f5a;
}
</style>
